import { lazy, Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Academics from './pages/Academics.jsx';
import Facilities from './pages/Facilities.jsx';
import News from './pages/News.jsx';
import Gallery from './pages/Gallery.jsx';
import Achievements from './pages/Achievements.jsx';
import Contact from './pages/Contact.jsx';
import NotFound from './pages/NotFound.jsx';
import Privacy from './pages/Privacy.jsx';
import RequireAuth from './auth/RequireAuth.jsx';
import Spinner from './shared/Spinner.jsx';

/*
 * The staff area is split out of the main bundle. No parent visiting the
 * homepage should download a dashboard they will never see — it is none of the
 * critical path and a fair slice of the JavaScript.
 *
 * The eight public pages are not split: they are static copy, they are
 * prerendered at build time, and a parent moving from Home to Admissions
 * should not sit waiting on a chunk to arrive.
 */
const StaffLogin = lazy(() => import('./pages/staff/Login.jsx'));
const StaffDashboard = lazy(() => import('./pages/staff/Dashboard.jsx'));

function StaffFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <Spinner label="Loading the dashboard" />
    </div>
  );
}

/** Layout route: header, footer and scroll handling wrap every public page. */
function PublicShell() {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<PublicShell />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/news" element={<News />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route
        path="/staff/login"
        element={
          <Suspense fallback={<StaffFallback />}>
            <StaffLogin />
          </Suspense>
        }
      />
      <Route
        path="/staff"
        element={
          <Suspense fallback={<StaffFallback />}>
            <RequireAuth>
              <StaffDashboard />
            </RequireAuth>
          </Suspense>
        }
      />
    </Routes>
  );
}
